import { CircularProgress } from '@mui/material';
import AppAdminTable from 'components/AppAdminTable/AppAdminTable';
import ListPage from 'components/ListPage/ListPage';
import Pagination from 'components/Pagination/Pagination';
import { TableColumns } from 'helpers/tableColumns';
import { useRemoteResource } from 'hooks/useRemoteResource';
import duasSAService from 'services/superadmin/duasSAService';

const listConfig = [
    {
        key: "order",
        label: "#",
        render: (v, i) => i + 1
    },
    {
        key: 'name',
        label: 'Название'
    },
    {
        key: "duaCategory.name",
        label: "Категория",
    },
    {
        key: "language",
        label: "Язык",
    },
    {
        key: "status",
        label: "Статус",
        formatter: (v) => v ? 'Активный' : 'Неактивный'
    },
    TableColumns.createdDate,
]

export const DuaList = () => {
    const [data, loadData, loading] = useRemoteResource(duasSAService.getAll, "");

    const onDelete = async (u) => {
        await duasSAService.delete(u.id);
        loadData();
    };

    if (loading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <ListPage pageTitle="Список дуа">
            <AppAdminTable
                columnConfig={listConfig}
                data={data?.data || []}
                onDelete={onDelete}
                loading={loading}
            />
            {data && <Pagination total={data.total} limit={50} />}
        </ListPage>
    );
}
